import type { ReactNode } from "react";
import { cx } from "./cx";

export interface TabItem<K extends string = string> { key: K; label: ReactNode; count?: number }

export function Tabs<K extends string>({ items, value, onChange }: { items: TabItem<K>[]; value: K; onChange: (k: K) => void }) {
  return (
    <ul className="ax-tabs" role="tablist">
      {items.map((it) => (
        <li key={it.key} role="presentation">
          <button type="button" role="tab" aria-selected={it.key === value} className={cx("ax-tab", it.key === value && "is-active")} onClick={() => onChange(it.key)}>
            {it.label}
            {it.count != null && <span className="ax-count">{it.count}</span>}
          </button>
        </li>
      ))}
    </ul>
  );
}
